module.exports = function() {
  return new Worker(__webpack_public_path__ + "84aaea8a3dd6a7540a21.worker.js");
};